import React from 'react';
import { Row, Col } from 'react-bootstrap';
import './App.css';
import Menu from './Menu';
import NavigationBar from "./NavigationBar";

const Layout = ({ children }) => {
    return (
      <div>
          <Row>
              <Col>
                  <NavigationBar />
              </Col>
          </Row>
            <Row>
              <Col xs="auto" className="sidebar">
                <Menu />
              </Col>
              <Col className="main-content">
                {children}
              </Col>
            </Row>
          </div>
    );
};

export default Layout;